export var SortOrder = /*#__PURE__*/ function(SortOrder) {
    SortOrder["SORT_ORDER_UNKNOWN"] = "SORT_ORDER_UNKNOWN";
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
    return SortOrder;
}({});
